import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        background: '#000',
        color: '#fff',
        padding: '64px 100px',

        [theme.breakpoints.down('sm')]: {
            padding: '48px 24px 40px 24px',
        },

    },
    container: {
        maxWidth: '1366px',
        margin: '0 auto',
    },
    newsletterSection: {
        textAlign: 'center',
        [theme.breakpoints.up('md')]: {
            marginBottom: 64
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        }
    },
    newsletterTitle: {
        fontSize: '36px',
        fontWeight: '700',
        color: '#fff',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
        }
    },
    newsletterForm: {
        marginTop: 32,
        display: 'flex',
        justifyContent: 'center',
        gap: '16px',
        maxWidth: '500px',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            marginTop: 16,
            width: '100%'
        }
    },
    emailInput: {
        [theme.breakpoints.up('md')]: {
            flex: '1',
        },
        padding: '0px 16px',
        height: 44,
        fontSize: '14px',
        border: 'none',
        borderRadius: '12px',
        background: '#27272A',
        color: '#fff',
        '&::placeholder': {
            color: '#999',
        },
        '&:focus': {
            outline: 'none',
            boxShadow: 'none',
            border: '1px solid #403DE3'
        }
    },
    subscribeButton: {
        height: 44,
        padding: '0 24px',
        fontSize: '14px',
        fontWeight: '700',
        color: '#fff',
        background: '#403DE3',
        border: 'none',
        borderRadius: 12,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        minWidth: 160,
        '&:hover': {
            background: '#403DE3',
            transform: 'translateY(-2px)',
        },
        [theme.breakpoints.down('sm')]: {
            margin: '0 auto',
        }
    },
    disabledButton: {
        background: '#6B7280 !important',
        cursor: 'not-allowed !important',
        opacity: 0.6,
        '&:hover': {
            background: '#6B7280 !important',
            transform: 'none !important',
        }
    },
    loadingContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
    },
    spinner: {
        width: '16px',
        height: '16px',
        border: '2px solid rgba(255, 255, 255, 0.3)',
        borderTop: '2px solid #fff',
        borderRadius: '50%',
        animation: '$spin 1s linear infinite',
    },
    '@keyframes spin': {
        '0%': {
            transform: 'rotate(0deg)',
        },
        '100%': {
            transform: 'rotate(360deg)',
        },
    },
    mainFooter: {
    },
    footerColumns: {
        [theme.breakpoints.up('md')]: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr',
            gap: '80px',
            alignItems: 'flex-start',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%'
        }
    },

    mobileLinkList: {
        [theme.breakpoints.down('sm')]: {
            marginTop: 32,
        }
    },
    footerColumn: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        }
    },
    companyInfo: {
        marginBottom: 16,
    },
    logo: {
        '& > img': {
            width: '175px',
            height: '45px',
            objectFit: 'contain',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }
    },
    logoIcon: {
        width: '48px',
        height: '48px',
        background: '#667eea',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '24px',
        fontWeight: '700',
        color: '#fff',
    },
    companyName: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#fff',
    },
    appRatings: {
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        [theme.breakpoints.down('sm')]: {
            gap: '16px',
            borderBottom: '1px solid #374151',
            paddingBottom: 32,
            marginBottom: 32,
        }
    },
    ratingItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
            alignItems: 'center',
        }
    },
    storeName: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#9CA3AF',
    },
    stars: {
        display: 'flex',
        gap: '4px',
        '& > img': {
            width: '20px',
            height: '20px',
        },
    },
    ratingScore: {
        fontSize: '20px',
        fontWeight: '800',
        color: '#fff',
    },
    columnTitle: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#fff',
        margin: '0 0 24px 0',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        }
    },
    linkList: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        [theme.breakpoints.down('sm')]: {
            gap: '8px',
            textAlign: 'center',
        }
    },
    footerLink: {
        color: '#9CA3AF',
        textDecoration: 'none',
        fontSize: '16px',
        fontWeight: '400',
        transition: 'color 0.3s ease',
        '&:hover': {
            color: '#fff',
        },
    },
    bottomSection: {
        borderTop: '1px solid #374151',
        paddingTop: '48px',
        marginTop: 48,
        [theme.breakpoints.down('sm')]: {
            marginTop: 32,
            paddingTop: 32,
        }
    },
    separator: {
        height: '1px',
        background: '#333',
        marginBottom: '40px',
    },
    bottomContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: '16px',
        }
    },
    copyright: {
        fontSize: '16px',
        color: '#BDBCFF',
        fontWeight: '400',
    },
    languageSelectorContainer: {
        position: 'relative',
    },
    languageSelector: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        cursor: 'pointer',
        padding: '8px 16px',
        borderRadius: '6px',
        transition: 'background 0.3s ease',
        '&:hover': {
            background: 'rgba(255, 255, 255, 0.1)',
        }
    },
    flagIcon: {
        width: '20px',
        height: '16px',
        borderRadius: '2px',
        // PNG bendera 209x129 (1.62:1) dipaksa ke 20x16 (1.25:1) — crop, jangan stretch.
        objectFit: 'cover',
    },
    dropdownArrow: {
        transition: 'transform 0.3s ease',
    },
    rotateArrow: {
        transform: 'rotate(180deg)',
    },
    languageDropdown: {
        position: 'absolute',
        bottom: '100%',
        right: '0',
        background: '#1a1a1a',
        border: '1px solid #374151',
        borderRadius: '8px',
        padding: '8px 0',
        marginBottom: '8px',
        minWidth: '180px',
        zIndex: 1000,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
    },
    languageOption: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '12px 16px',
        cursor: 'pointer',
        transition: 'background 0.3s ease',
        '&:hover': {
            background: 'rgba(255, 255, 255, 0.1)',
        }
    },
    selectedLanguage: {
        background: 'rgba(102, 126, 234, 0.2)',
        color: '#667eea',
    },
    ctnRating: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
        }
    },
    mobileTopSection: {
        marginTop: 12
    }
}));

export default useStyles;
